export type CreateCollectionType = 'new' | 'edit' | 'new-from';
